import { render, staticRenderFns } from "./AdminDeviceCommandQueue.vue?vue&type=template&id=61151b6b&scoped=true&"
import script from "./AdminDeviceCommandQueue.vue?vue&type=script&lang=js&"
export * from "./AdminDeviceCommandQueue.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeviceCommandQueue.vue?vue&type=style&index=0&id=61151b6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61151b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61151b6b')) {
      api.createRecord('61151b6b', component.options)
    } else {
      api.reload('61151b6b', component.options)
    }
    module.hot.accept("./AdminDeviceCommandQueue.vue?vue&type=template&id=61151b6b&scoped=true&", function () {
      api.rerender('61151b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminDeviceCommandQueue.vue"
export default component.exports